var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRank2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72.367,
    height: 102.227,
    viewBox: "0 0 72.367 102.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#adadad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ababab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M68.132,249.951v49.282l23.406-9.269,22.686,9.269V249.951Z",
    transform: "translate(-68.132 -249.951)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M84.466,297.236l-2,.794V249.951h2Z",
    transform: "translate(-82.462 -249.951)",
    fill: "#e9e9e9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M262.722,297.236l2.006.794V249.951h-2.006Z",
    transform: "translate(-262.722 -249.951)",
    fill: "#e9e9e9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M36.54,2.139,34.274.451,32.236,2.406,29.777,1.014,28,3.211,25.385,2.139,23.9,4.541,21.17,3.808,20,6.38l-2.8-.386-.839,2.7-2.826-.032-.5,2.783-2.807.32-.146,2.821-2.745.669.208,2.817L4.911,19.081l.559,2.769L2.979,23.182l.9,2.675-2.3,1.635,1.235,2.542L.734,31.947l1.544,2.366L.452,36.469l1.826,2.156L.734,40.992,2.814,42.9,1.579,45.446l2.3,1.633-.9,2.677,2.491,1.33-.559,2.771L7.55,54.864l-.208,2.817,2.745.669.146,2.821,2.807.322.5,2.781,2.826-.032.839,2.7,2.8-.383,1.171,2.569,2.728-.733,1.487,2.4L28,69.727l1.777,2.2,2.459-1.394,2.038,1.955L36.54,70.8,38.8,72.485l2.04-1.955L43.3,71.924l1.777-2.2L47.695,70.8l1.485-2.4,2.731.735,1.169-2.572,2.8.383.839-2.7,2.826.032.5-2.781,2.807-.322.146-2.821,2.745-.669-.208-2.817,2.639-1.006-.559-2.771,2.493-1.33-.9-2.675,2.3-1.635L70.268,42.9l2.078-1.913L70.8,38.625l1.826-2.156L70.8,34.313l1.544-2.366-2.078-1.913L71.5,27.492l-2.3-1.635.9-2.675L67.61,21.849l.559-2.769L65.53,18.072l.208-2.817-2.745-.667-.146-2.824-2.807-.32-.5-2.781-2.826.03L55.879,6l-2.8.383L51.91,3.808l-2.731.733-1.485-2.4L45.081,3.211,43.3,1.014,40.844,2.406,38.8.451Z",
    transform: "translate(-0.452 -0.451)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_362",
    "data-name": "Rectangle 362",
    width: 72.367,
    height: 102.227,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M24.867,52.578A28.051,28.051,0,1,1,52.918,80.63,28.084,28.084,0,0,1,24.867,52.578m-3.635,0A31.686,31.686,0,1,0,52.918,20.892,31.687,31.687,0,0,0,21.232,52.58",
    transform: "translate(-21.232 -20.892)",
    fill: "url(#linear-gradient-2)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rank_2",
    "data-name": "Rank 2",
    transform: "translate(-34.1 -469.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15405",
    "data-name": "Group 15405",
    transform: "translate(34.1 469.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722",
    transform: "translate(14.432 52.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_358",
    "data-name": "Rectangle 358",
    width: 46.092,
    height: 49.282,
    fill: "#d8d8d8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724",
    transform: "translate(17.467 52.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_359",
    "data-name": "Rectangle 359",
    width: 35.414,
    height: 35.414,
    transform: "translate(-24.04 24.04) rotate(-45)",
    fill: "#e9e9e9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726",
    transform: "translate(55.65 52.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_360",
    "data-name": "Rectangle 360",
    width: 35.416,
    height: 35.416,
    transform: "translate(-24.04 24.04) rotate(-45)",
    fill: "#e9e9e9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728",
    transform: "translate(0.096 0.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361",
    "data-name": "Rectangle 361",
    width: 95.857,
    height: 95.789,
    transform: "translate(-27.592 12.867) rotate(-25.001)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M72.628,36.469,70.8,38.625l1.544,2.366L70.268,42.9,71.5,45.446l-2.3,1.635.9,2.675-2.493,1.33.559,2.771L65.53,54.864l.208,2.817-2.745.669-.146,2.821-2.807.322-.5,2.781-2.826-.032-.839,2.7-2.8-.383L51.91,69.13l-2.73-.735-1.485,2.4-2.614-1.072-1.777,2.2L40.844,70.53,38.8,72.485,36.54,70.8l-2.266,1.688L32.236,70.53l-2.459,1.394L28,69.727,25.385,70.8l-1.487-2.4-2.728.733L20,66.558l-2.8.383-.839-2.7-2.826.032-.5-2.781-2.807-.322-.146-2.821-2.745-.669.208-2.817L4.911,53.858l.559-2.771-2.491-1.33.9-2.677-2.3-1.633L2.814,42.9.734,40.992l1.544-2.366L.452,36.469l1.826-2.156L.734,31.947l2.08-1.913L1.579,27.492l2.3-1.635-.9-2.675L5.47,21.849l-.559-2.769L7.55,18.072l-.208-2.817,2.745-.669.146-2.821,2.807-.32.5-2.783,2.826.032.839-2.7L20,6.38,21.17,3.808l2.728.733,1.487-2.4L28,3.211l1.777-2.2,2.459,1.392L34.274.451,36.54,2.139,38.8.451l2.04,1.955L43.3,1.014l1.777,2.2,2.614-1.072,1.485,2.4,2.73-.733L53.081,6.38,55.879,6l.839,2.7,2.826-.03.5,2.781,2.807.32.146,2.824,2.745.667-.208,2.817,2.639,1.008-.559,2.769L70.1,23.182l-.9,2.675,2.3,1.635-1.235,2.542,2.078,1.913L70.8,34.313Z",
    transform: "translate(-0.356 -0.355)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.69
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732",
    transform: "translate(4.497 4.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_363",
    "data-name": "Rectangle 363",
    width: 89.624,
    height: 89.624,
    transform: "translate(-31.687 31.687) rotate(-45)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M52.918,20.892A31.687,31.687,0,1,0,84.6,52.58,31.687,31.687,0,0,0,52.918,20.892Zm0,59.738A28.052,28.052,0,1,1,80.97,52.578,28.084,28.084,0,0,1,52.918,80.63Z",
    transform: "translate(-16.735 -16.467)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 27.638,
    cy: 27.638,
    rx: 27.638,
    ry: 27.638,
    transform: "translate(8.408 8.333)",
    fill: "none",
    stroke: "#251e1c",
    strokeMiterlimit: 10,
    strokeWidth: 2.02
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M92.812,63.812a28.67,28.67,0,1,1-28.67-28.67A28.669,28.669,0,0,1,92.812,63.812Z",
    transform: "translate(-27.958 -27.698)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.86
  })))), /*#__PURE__*/React.createElement("text", {
    id: "_2nd",
    "data-name": "2nd",
    transform: "translate(54.783 516)",
    fill: "#202020",
    fontSize: 24,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 13.999,
    baselineShift: 7.999199924145271
  }, "nd")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank2);
export default __webpack_public_path__ + "static/media/Rank 2.56be11115b5ef4a041ec08245195bab0.svg";
export { ForwardRef as ReactComponent };